module.exports = __webpack_public_path__ + "static/media/open-map.8a5810fa.svg";